import styled from '@emotion/styled';
import React from 'react';
import { Link } from '@mui/material';
import { Trans } from 'react-i18next';

const BannerContainer = styled.div`
  background-color: #721e60;
  display: flex;
  height: 34px;
  width: 100%;
  color: white;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const BannerText = styled.p`
  color: #fff;
  font-size: 0.659rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  letter-spacing: 0.02em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const ReadMoreLink = styled(Link)`
  color: #fff;
  line-height: normal;
  letter-spacing: -0.01em;
  text-decoration: none;
  font-weight: 100;
  border-bottom: 1px solid #fff;
  &:hover {
    border-bottom: 1px solid transparent;
  }
`;

const EthocaLink = styled(Link)`
  color: #fff;
  line-height: normal;
  text-decoration: none;
  border-bottom: 1px solid #fff;
  letter-spacing: -0.01em;

  &:hover {
    border-bottom: 1px solid transparent;
  }
`;

export const LowercaseText = styled('span')`
  text-transform: lowercase;
`;

export const AcquisitionBanner = () => {
  return (
    <BannerContainer>
      <BannerText>
        <Trans
          ns="headerFooter"
          i18nKey="banner_text"
          components={{
            partnerLink: <EthocaLink href="https://www.ethoca.com/" target="_blank" rel="noopener noreferrer" />,
            readMoreLink: (
              <ReadMoreLink
                href="https://newsroom.mastercard.com/news/perspectives/2024/sign-us-up-transforming-the-subscription-experience/"
                target="_blank"
                rel="noopener noreferrer"
              />
            ),
          }}
        />
      </BannerText>
    </BannerContainer>
  );
};
